import { render } from "./KatsinaLgaMap.vue?vue&type=template&id=6531ee6a&scoped=true"
import script from "./KatsinaLgaMap.vue?vue&type=script&lang=js"
export * from "./KatsinaLgaMap.vue?vue&type=script&lang=js"

import "./KatsinaLgaMap.vue?vue&type=style&index=0&id=6531ee6a&scoped=true&lang=css"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geomaps-pension/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6531ee6a"]])

export default __exports__